export function createCircle(_a) {
    var size = _a.size, width = _a.width;
    var sizeString = size.toString();
    var el = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    el.setAttribute('cx', sizeString);
    el.setAttribute('cy', sizeString);
    el.setAttribute('r', (size - width).toString());
    el.setAttribute('fill', 'none');
    el.setAttribute('stroke-width', width.toString());
    return el;
}
